/* Brief reading controls and explicit cover-click playback. No autoplay or tracking. */
(() => {
  if (window.marsyuBriefGuideReady) return;
  window.marsyuBriefGuideReady = true;
  const reveal = () => {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    if (!id) return;
    const target = document.getElementById(id);
    if (!target || !target.closest('.mcg')) return;
    let node = target;
    while (node) {
      if (node.tagName === 'DETAILS') node.open = true;
      node = node.parentElement;
    }
    target.scrollIntoView({ block: 'start', behavior: 'instant' });
    const focusTarget = target.tagName === 'DETAILS' ? target.querySelector('summary') : target;
    if (focusTarget) {
      if (!focusTarget.hasAttribute('tabindex') && focusTarget.tagName !== 'SUMMARY') focusTarget.tabIndex = -1;
      focusTarget.focus({ preventScroll: true });
    }
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.mcg a[href^="#"]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.hash !== location.hash) location.hash = link.hash;
    reveal();
  });
  window.addEventListener('hashchange', reveal);
  document.addEventListener('toggle', (event) => {
    const detail = event.target;
    if (detail.tagName === 'DETAILS' && !detail.open && detail.closest('.mcg')) {
      detail.querySelectorAll('video').forEach((video) => video.pause());
    }
  }, true);
  document.querySelectorAll('.mcg-reference-media').forEach((media) => {
    const video = media.querySelector('video');
    const button = media.querySelector('.mcg-video-play');
    const status = media.querySelector('.mcg-video-status');
    if (!video || !button) return;
    button.hidden = false;
    video.tabIndex = 0;
    button.addEventListener('click', async () => {
      // Playback is requested only by this explicit user activation.
      button.hidden = true;
      status.hidden = true;
      try {
        await video.play();
        video.focus({ preventScroll: true });
      } catch {
        status.hidden = false;
        video.focus({ preventScroll: true });
      }
    });
    video.addEventListener('play', () => {
      button.hidden = true;
      status.hidden = true;
      document.querySelectorAll('.mcg-reference-video').forEach((other) => { if (other !== video) other.pause(); });
    });
    video.addEventListener('ended', () => { button.hidden = false; });
  });
  if ('IntersectionObserver' in window) {
    // Leaving the page section can pause a video; entering never starts one.
    const offscreen = new IntersectionObserver((entries) => {
      entries.forEach(({target, isIntersecting}) => { if (!isIntersecting) target.pause(); });
    }, { threshold: 0 });
    document.querySelectorAll('.mcg-reference-video').forEach(video => offscreen.observe(video));
  }
  reveal();
})();
